module.exports = function() {
  return new Worker(__webpack_public_path__ + "3bebd50887c97b264690.worker.js");
};